import axios from 'axios'
import store from '@/store'
import { encrypt, checkDigest, decrypt } from '@/utils/jm'
import router from '@/router'
var service = axios.create({
  // baseURL: 'http://192.168.1.233:9521/app',
  timeout: 50000 ,// request timeout
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }
})
service.interceptors.request.use(
  config => {
    config.data = encrypt(JSON.stringify(config.data))
    return config
  },
  error => {
     return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.data.result == -99 || response.data.code == 2) {
      // store.commit('setoken', '')
      // store.commit('setuser', '')
      // store.commit('setphone', '')
      // router.push("/sacrifice/login")
    }else{
      if (response.data.result == 0) {
        let flag = checkDigest(response.data.digest, response.data.body, response.data.ts)
        return flag ? decrypt(response.data.body,'UX00H5n2BN7L4Y5H') : false
      }
    }
  },
  error => {
    console.log( error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/axios/parkUrl.js